<template>
  <div class="container-outer">
    <div class="prompts-navbar">
      <router-link
        :class="[{ selected: $route.name === 'promptlibrary' }, 'prompts-navbar-item']"
        to="/prompts/library"
      >
        Prompt Library
      </router-link>
      <router-link
        :class="[{ selected: $route.name === 'promptpacks' }, 'prompts-navbar-item']"
        to="/prompts/packs"
      >
        Prompt Packs
      </router-link>
    </div>
    <div class="container-center">
      <router-view />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'PromptsScreen',
  data: () => ({
    isUserOnTeam: false
  }),
  computed: {
    auth0UserId: function () {
      return this.$auth.user.sub.replace(/\|/g, '_');
    },
    idToken: function () {
      return this.$auth.idToken;
    }
  },
  methods: {
    async checkUserIsOnTeam() {
      const response = await this.axios.post(`${ process.env.VUE_APP_BACKEND_API_URL }/checkuserisonteam`, {
        auth0UserId: this.auth0UserId
      }, {
        headers: {
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${this.idToken}`
        }
      });

      this.isUserOnTeam = response.data.isUserOnTeam || false;
    }  
  },
  created: async function () {
    await this.checkUserIsOnTeam();
  }
})
</script>

<style scoped lang="scss">
.container-outer {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: $dark-brown;
  top: 6em;
  left: 14em;
  right: 4%;
  bottom: 2em;
}

.prompts-navbar {
  position: fixed;
  top: 0;
  left: -2em;
  bottom: 0;
  padding-top: 6em;
  width: 12em;
  font-size: 1.1em;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.prompts-navbar-item {
  padding: 0.4em 0.8em 0.4em 4em;
  font-weight: initial;
  &:hover {
    color: $natural-white;
    background-color: $light-lilac-purple;
    border-radius: 0.6em;
  }
}

.prompts-navbar-item.selected {
  margin-left: -1em;
  color: $natural-white;
  background-color: $lilac-purple;
  border-radius: 0.6em;
}
</style>
